import { ObjectMap } from '@ringcentral-integration/core/lib/ObjectMap';

export const extendedControlStatus = ObjectMap.fromKeys([
  'pending',
  'playing',
  'stopped',
]);
